import { render, staticRenderFns } from "./AddBuildingForUser.vue?vue&type=template&id=3a09eb69&"
import script from "./AddBuildingForUser.vue?vue&type=script&lang=js&"
export * from "./AddBuildingForUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports